export const selectTypeSort = (state) => state.mainReducer.sort;
